var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('result-card',{attrs:{"question":_vm.question,"status":"wrong"}},[_c('template',{slot:"score-icon"},[_c('close-icon',{attrs:{"fillColor":"#dc5a59"}})],1),_c('template',{slot:"score-name"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }